import {Dialog, DialogContent, DialogHeader, DialogTitle} from "@/components/ui/dialog.tsx";
import {Button} from "@/components/ui/button.tsx";
import FieldArray from "@/components/form/FieldArray.tsx";
import CurrencyField from "@/components/editor/fields/CurrencyField.tsx";
import Field from "@/components/form/Field.tsx";
import {ChartLineIcon, PlusIcon, Trash} from "lucide-react";
import {useState} from "react";
import TorzsgardaDetails, {TorzsgardaCalc} from "@/components/editor/TorzsgardaDetails.tsx";
import axios from "axios";


export default function TorzsgardaDialog() {
    const [detailsOfIndex, setDetailsOfIndex] = useState<number | null>(null);
    const [calcs, setCalcs] = useState<Dictionary<TorzsgardaCalc | undefined>>({});
    return (
        <>
            <Dialog open={detailsOfIndex != null} onOpenChange={()=> setDetailsOfIndex(null)}>
                <DialogContent
                    className={"w-[80vw] h-[80vh] max-w-[100vw_!important] flex flex-col overflow-y-auto"}>
                    <DialogHeader>
                        <DialogTitle className={"text-center"}>Törzsgárda</DialogTitle>
                    </DialogHeader>
                    <FieldArray name={"torzsgardaArray"}>
                        {(array) => array.map((val, index) => {
                                if (index == detailsOfIndex)
                                    return (
                                        <>
                                            <TorzsgardaDetails key={val.key} values={val.getValues()}
                                                               onClose={() => setDetailsOfIndex(null)}/>
                                        </>
                                    )
                                else return <> </>;
                            }
                        )}
                    </FieldArray>
                </DialogContent>
            </Dialog>
            <div className={"grid gap-4 grid-cols-[1fr_1fr_1fr_auto_auto] py-4 w-full"}>
                <p className={"text-center font-black text-secondary-foreground"}>Havi összeg</p>
                <p className={"text-center font-black text-secondary-foreground"}>Mód</p>
                <p className={"text-center font-black text-secondary-foreground"}>Megtakarítás</p>
                <div></div>
                <div></div>
                <FieldArray name={"torzsgardaArray"} defaultValue={[{}]} end={(actions) => {
                    return (
                        <div className={"flex justify-center col-span-5"}>
                            <Button onClick={() => actions.add({})} className={"col-span-5 w-full"}>
                                <PlusIcon/>
                            </Button>
                        </div>
                    )
                }}>
                    {(array) => (
                        array.map((_, index) => {
                            function getCalc(key: string, value: any) {
                                axios.post('/api/torzsgarda', {
                                    ..._.getValues(),
                                    [key]: value
                                }).then((res) => {
                                    console.log(res.data)
                                    setCalcs({...calcs, [_.key]: res.data})
                                })
                            }

                            return (<>
                                <CurrencyField defaultValue={{value: 100000, valuta: 'HUF'}}
                                               onBlur={(v) => {
                                                   getCalc('value', v)
                                               }} name={"value"} label={""}/>
                                <div className={"flex gap-2 justify-center"}>
                                    <Field name={"mode"} defaultValue={true}>
                                        {(field) => (
                                            <>
                                                <Button onClick={() => {
                                                    field.onChange(true)
                                                    getCalc("mode", true)
                                                }}
                                                        variant={field.value ? "default" : "outline"}>Nettó</Button>
                                                <Button onClick={() => {
                                                    field.onChange(false)
                                                    getCalc("mode", false)
                                                }}
                                                        variant={!field.value ? "default" : "outline"}>Bruttó</Button>
                                            </>
                                        )}
                                    </Field>
                                </div>
                                {/*
                                <Field name={"years"} defaultValue={"10"}>
                                    {(field) => (
                                        <Select defaultValue={field.value}
                                                onValueChange={(v) => {
                                                    field.onChange(v);
                                                    getCalc("years", v)
                                                }}>
                                            <SelectTrigger>
                                                <SelectValue placeholder={"Év"}/>
                                            </SelectTrigger>
                                            <SelectContent>
                                                <SelectItem value={"1"}>1</SelectItem>
                                                <SelectItem value={"5"}>5</SelectItem>
                                                <SelectItem value={"10"}>10</SelectItem>
                                            </SelectContent>
                                        </Select>
                                    )}
                                </Field>*/}
                                <div className={"h-9 justify-center flex items-center text-primary font-black"}>{
                                    ((calcs[_.key]?.lojalitas.true_ado[parseInt(_.getValues().years) - 1] ?? 4907041) - (calcs[_.key]?.torzsgarda.ado[parseInt(_.getValues().years) - 1] ?? 0)).toLocaleString('hu-HU', {maximumFractionDigits: 0})} {(_.getValues()?.["value"]?.["valuta"] ?? "HUF") == "HUF" ? "Ft" : "€"}
                                </div>
                                <Button onClick={() => setDetailsOfIndex(index)}>
                                    <ChartLineIcon/>
                                </Button>
                                <Button variant={"outline"} onClick={() => _.remove(index)}
                                        className={"w-10 h-9"}>
                                    <Trash/>
                                </Button>
                            </>)
                        })
                    )}
                </FieldArray>
            </div>
        </>
    )
        ;
}